// extracted by mini-css-extract-plugin
module.exports = {"cardSetNewPass":"styles_cardSetNewPass__2RQdj","setNewPassButton":"styles_setNewPassButton__73F9S","setNewPassViewStyle":"styles_setNewPassViewStyle__quaQs"};